import { render, staticRenderFns } from "./TemplateShow.vue?vue&type=template&id=444160ae"
import script from "./TemplateShow.vue?vue&type=script&lang=ts"
export * from "./TemplateShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports